(function (window) {
    var Dustars = function () {

    };

    if (!window.dustars) {
        window.dustars = {};
    }

    if (!window.Dustars) {
        window.Dustars = new Dustars();
    }

}(window));